import React from 'react'
import { MailingSettingsErrorsInterface } from '../types/mailing-settings-interface'

export const ErrorMessagesForEmailFooter = React.memo(
  ({
    errors,
    emailFooterOptions,
  }: {
    errors: MailingSettingsErrorsInterface
    emailFooterOptions?: Array<{ id: string; caption: string }>
  }) => {
    if (!emailFooterOptions) return null

    const filteredErrors = Object.entries(errors)
      .filter(([key, value]) => key.endsWith('.content') && typeof value === 'string')
      .map(([key, value]) => {
        const index = key.split('[')[1]?.split(']')[0]
        return `${emailFooterOptions?.[Number(index)]?.caption}: ${value}`
      })

    if (!filteredErrors.length) return null

    return <p className="text-red text-sm">{filteredErrors.join(', ')}</p>
  },
)

ErrorMessagesForEmailFooter.displayName = 'ErrorMessagesForEmailFooter'
